/* handpanladen · Klangprobe-Abspieler · N68, erweitert um Wistia-Ton (24.09.2026),
   seit 25.09.2026 global (Max: YouTube komplett raus, product-card.liquid + hpl-coll-card.liquid
   teilen sich diese Datei statt eines separaten YouTube-Popups).
   Klangproben als direkte Audio-Wiedergabe: ein geteiltes Audio-Element,
   Play/Pause am Button, kein Popup, kein externes Script.
   – data-clx-mp3="URL":   MP3 direkt.
   – data-clx-wistia="ID": Ton der Wistia-Klangprobe. Erst beim Klick wird die Dateiliste
     (fast.wistia.com/embed/medias/ID.json) geholt und die kleine mp4 als Audio gestreamt;
     beim Seitenaufbau wird nichts geladen.
   Startet eine neue Probe, stoppt die laufende automatisch.
   Tracking sound_sample_play (übernommen aus dem alten hpl-cards.js, erweitert um den Kompass):
   source_module unterscheidet die native Produktkarte (<product-card>, z. B. Empfehlungen/
   Suche), das Kompass-Ergebnis (.hpl-kmp) und – als Rückfall – die Collection-Karte
   (.clx-card, z. B. handpan-kaufen). */
(function () {
  'use strict';
  if (window.__hplCollInit) return;
  window.__hplCollInit = true;

  /* Winzige stille WAV: entsperrt das Audio-Element im Klick (iOS/Safari erlaubt play()
     sonst nur synchron im Klick, der Wistia-Abruf ist aber asynchron). */
  var STILL = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';

  var audio = null;
  var aktiverBtn = null;
  var lauf = 0;      // erhöht sich bei jedem Stopp/Start: verwirft veraltete Abrufe
  var urls = {};     // Wistia-ID → Promise mit der Datei-URL

  function stopp() {
    lauf++;
    if (audio) audio.pause();
    if (aktiverBtn) {
      aktiverBtn.classList.remove('is-playing');
      aktiverBtn.setAttribute('aria-pressed', 'false');
      aktiverBtn = null;
    }
  }

  function ende() {
    if (audio && audio.src.indexOf('data:') === 0) return; // Stille-Entsperrung, keine echte Probe
    stopp();
  }

  function wistiaUrl(id) {
    if (!urls[id]) {
      urls[id] = fetch('https://fast.wistia.com/embed/medias/' + encodeURIComponent(id) + '.json')
        .then(function (r) {
          if (!r.ok) throw new Error('Wistia ' + r.status);
          return r.json();
        })
        .then(function (j) {
          var assets = (j && j.media && j.media.assets) || [];
          var beste = null;
          assets.forEach(function (a) {
            if (!a || !a.url || a.container !== 'mp4' || a.public === false) return;
            var rang = a.type === 'iphone_video' ? 0 : 1; // 360p (FastStart) bevorzugt, sonst kleinste
            var rate = a.bitrate || 99999;
            if (!beste || rang < beste.rang || (rang === beste.rang && rate < beste.rate)) {
              beste = { url: a.url, rang: rang, rate: rate };
            }
          });
          if (!beste) throw new Error('Keine mp4 gefunden');
          return beste.url;
        });
      urls[id].catch(function () { delete urls[id]; }); // Fehlschlag nicht cachen
    }
    return urls[id];
  }

  function starten(url, mein) {
    if (mein !== lauf) return; // in der Zwischenzeit gestoppt oder andere Probe gestartet
    audio.src = url;
    var p = audio.play();
    if (p && p.catch) p.catch(function () { if (mein === lauf) stopp(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-clx-mp3], [data-clx-wistia]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (btn === aktiverBtn) { stopp(); return; }

    if (!audio) {
      audio = new Audio();
      audio.preload = 'none';
      audio.addEventListener('ended', ende);
      audio.addEventListener('error', ende);
    }
    stopp();
    var mein = lauf;
    aktiverBtn = btn;
    btn.classList.add('is-playing');
    btn.setAttribute('aria-pressed', 'true');

    if (window.hplTrack) {
      var quelle = 'collection-card';
      if (btn.closest('product-card')) quelle = 'product-card';
      else if (btn.closest('.hpl-kmp')) quelle = 'kompass-ergebnis';
      window.hplTrack('sound_sample_play', {
        source_module: quelle,
        product_handle: btn.getAttribute('data-handle') || ''
      });
    }

    var mp3 = btn.getAttribute('data-clx-mp3');
    if (mp3) { starten(mp3, mein); return; }

    audio.src = STILL;
    var still = audio.play();
    if (still && still.catch) still.catch(function () {});
    wistiaUrl(btn.getAttribute('data-clx-wistia')).then(
      function (url) { starten(url, mein); },
      function () { if (mein === lauf) stopp(); }
    );
  });
})();
